module.exports = __webpack_public_path__ + "img/Request Demo Arrow-small.3505e0ed.svg";